import React from "react";
import Logo from "./assets/LandingPageLogo.png";
import { Link } from "react-router";
import { detectMobile, getLogoStyle } from "../services/utils";

function WelcomePage(props) {
  const isMobile = detectMobile();
  const logoStyle = getLogoStyle(isMobile);

  const secondButtonStyle = isMobile
    ? {
        marginTop: "20px",
        marginBottom: "20px"
      }
    : {};

  return (
    <div className="container-fluid bg-color-blue height-100vh">
      <div className="text-center mg-top-15vh">
        <img src={Logo} style={logoStyle} alt="Logo" />
      </div>
      <div className="row mg-top-10vh">
        <div className="col-md-3 col-md-offset-3 col-xs-12">
          <Link to="/login" className="btn login-btn btn-lg btn-block">
            Login
          </Link>
        </div>
        <div className="col-md-3 col-xs-12">
          <Link
            to="/register"
            className="btn login-btn btn-lg btn-block"
            style={secondButtonStyle}
          >
            Register
          </Link>
        </div>
      </div>
    </div>
  );
}

export default WelcomePage;



// WEBPACK FOOTER //
// ./src/containers/welcome-page.js